import { render, staticRenderFns } from "./ListVideos.vue?vue&type=template&id=68502c5d&scoped=true"
import script from "./ListVideos.vue?vue&type=script&lang=js"
export * from "./ListVideos.vue?vue&type=script&lang=js"
import style0 from "./ListVideos.vue?vue&type=style&index=0&id=68502c5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68502c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/lgweek/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68502c5d')) {
      api.createRecord('68502c5d', component.options)
    } else {
      api.reload('68502c5d', component.options)
    }
    module.hot.accept("./ListVideos.vue?vue&type=template&id=68502c5d&scoped=true", function () {
      api.rerender('68502c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/ListVideos.vue"
export default component.exports